import React, { useState } from 'react';


export const BOUNDS = {
  // West, South, East, North
  // See helper script: get_dom_tom_bboxes.py
  metropole: [-5.38, 42.12, 8.32, 51.74],
  guadeloupe_and_co: [-63.123046875, 14.4262695312, -60.8262695312, 18.1153320312],
  reunion_and_co: [45.042578125, -21.3690429688, 55.8390625, -12.6530273438],
  nouvelle_caledonie_and_co: [-147.2695958876334, -11.53551524105012, -200.92349435638394, -28.288238467050014], // manual!!
  saint_pierre_et_miquelon: [-56.3869140625, 46.7528320312, -56.1373535156, 47.0989746094],
  guyane: [-54.6162597656, 2.12104492187, -51.6525390625, 5.7822265625],
  taaf: [51.6592773438, -49.7098632812, 70.55546875, -46.3268554687]
};


export default ({ setMapBounds }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const setBounds = (bounds) => () => setMapBounds(bounds);

  return (
    <div>
      <div id="gp-menu-dom" className="gp-act-button">
        <span>
          <a onClick={open}>
            Cartes des DROM-COM
          </a>
        </span>
      </div>
      <div id="gp-menu-dom-detail" className={`gp-popup-menu${isOpen ? '' : ' gp-hidden'}`}>
        <div class="gp-close-icon" onClick={close}>
          <span class="icon">
            <i class="fa fa-window-close"></i>
          </span>
        </div>
        <div class="gp-content gp-no-counter">
          <div class="content">
            <ul>
              <li>
                <a onClick={setBounds(BOUNDS.metropole)}>France métropolitaine</a>
              </li>
              <li>
                <a onClick={setBounds(BOUNDS.guadeloupe_and_co)}>Guadeloupe, Martinique, Saint-Barthélemy, Saint-Martin</a>
              </li>
              <li>
                <a onClick={setBounds(BOUNDS.reunion_and_co)}>Réunion, Mayotte</a>
              </li>
              <li>
                <a onClick={setBounds(BOUNDS.nouvelle_caledonie_and_co)}>Nouvelle-Calédonie, Polynésie française, Wallis-et-Futuna</a>
              </li>
              <li>
                <a onClick={setBounds(BOUNDS.saint_pierre_et_miquelon)}>Saint-Pierre-et-Miquelon</a>
              </li>
              <li>
                <a onClick={setBounds(BOUNDS.guyane)}>Guyane</a>
              </li>
              <li>
                <a onClick={setBounds(BOUNDS.taaf)}>Terres Australes et Antarctiques Françaises</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
